import { Help } from '@plasma/ui.application.app';

const help: Help[] = [
  // {
  //   title: 'CalculatedConsumablesDemand',
  //   description: 'description of CalculatedConsumablesDemand',
  //   url: '/calculated-consumables-demand',
  // },
];

export default help;
